import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";
const QualityEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [farmLists, setFarmLists] =  useState([]);
  const [productLists, setproductLists] = useState([]);
  const [locationLists, setLocationLists] = useState([]);
  const [permission, setPermission] = useState({});

  const [backendErrors, setBackendErrors] = useState([]);
  // const [customerNames, setcustomerNames] = useState([]);
  const [primaryCurrency, SetPrimaryCurrency] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const formik = useFormik({
    initialValues: {
      id: value.id,
      analysis_name: value.analysis_name,
      lab_name: value.lab_name,
      date: value.date,
      farm: value.farm,
      processing_line: value.processing_line,
      product_type:value.product_type,
      price: value.price,
      result: value.result,
      file: value.file,
      currency:value.currency,
      product:value.product,
      ram_lot_or_farm:value.ram_lot_or_farm,
   
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/qualities/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Quality");
           if (response.data.code === 200) {
             //setBackendSuccess(response.data.message);
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/qualities";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(261)); 
    console.log(permission);
    
    raw_data_invoice ='';
 
    axios
    .get(`/helpers/currencies`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let currencies = response.data.data.currencies;
        let currencieslisting = currencies.map((customer, index) => ({
          label: customer.title,
          value: customer.id,
          key: `farm-${index}`,
        }));
        SetPrimaryCurrency(currencieslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios
      .get(`/qualities/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         setValue(response.data.data.quality);
         axios.get(`/helper/currency-symbol-by-currency-id/${response.data.data.quality.currency}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
          // console.log(response.data.data);
            setCurrencySymbol(response.data.data.currency_symbol)
          
          }
        })
        .catch((error) => {
          console.log(error);
        });
        }
      })
      .catch((error) => {
        console.log(error);
      });

       axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          
           const productslisting = [
                  ...products.map((customer, index) => ({
                    label: customer.name,
                    value: customer.name,
                    key: `product-${index}`,
                  })),
                  ...["Eau d'irrigation", "Eau de station", "Eau de Ferme", "Surface", "Sol de ferme"].map((vall, index) => ({
                    label: vall,
                    value: vall,
                    key: `other-${index}`, // Different prefix to avoid key collision
                  }))
                ];

                console.log(productslisting);
                setproductLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
          axios .post(  "/farmers/listing", {},  {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              }
            ) .then((response) => {
              if (response.data.code === 200) {
                let orders = response.data.data.farmers;
                let orderslisting = orders.map((customer, index) => ({
                  label: customer.name,
                  value: customer.id,
                  key: `farm-${index}`,
                }));
                setFarmLists(orderslisting);
              } else {
                console.log("API response is not an array");
              }
            }).catch((error) => {
              console.log(error);
            });
             axios.get(`/helpers/loading-locations`, {
                headers: {
                  Authorization: `Bearer ${Authtoken}`,
                  Apitoken: Apitoken,
                },
              })
              .then((response) => {
                if (response.data.code === 200) {
                //   let locations = response.data.data.locations;
        
                  let productslisting = response.data.data.locations;
        
                  let locations = productslisting.map((customer, index) => ({
                    label: customer.title,
                    value: customer.id,
                    key: `location-${index}`,
                  }));
                  setLocationLists(locations);
                
                } else {
                  console.log("API response is not an array");
                }
              }).catch((error) => {
                console.log(error);
              });
    
  }, [id]);


  let raw_data_invoice ='';
  if(value.file){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.file};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
 
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  const customFuction = (event) =>{
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index];
    var key_sybmol =  optionElement.getAttribute('key_sybmol');
    console.log(key_sybmol);
    setCurrencySymbol(key_sybmol)
  
  }
   let productType = [
     { value: 'Raw Material', label: "Raw Material" },
    { value: 'Finished Product',label: "Finished Product" },
    { value: '-',label: "-" },
  ]
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Lab Analysis</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/qualities">Lab Analysis</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                    {permission && permission.update === 1 && (
                      <div className="card-body">
                        <h4 className="card-title">Lab Analysis Info</h4>
                        <FormikProvider value={formik}>
                          <form onSubmit={formik.handleSubmit}>
                            
                            
                          <div className="row">
                              <div className="col-md-6">
                              <div className="form-group">
                                  <label>Analysis Name</label>
                                  <input
                                    type="text"
                                    name="analysis_name"
                                    value={formik.values.analysis_name}
                                    className="form-input form-control datetimepicker"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.analysis_name && (
                                        <span className="form-error mt-1">
                                          {backendErrors.analysis_name}
                                        </span>
                                      )}
                                  </small>
                                </div>
                          </div>
                          <div className="col-md-6">
                              <div className="form-group">
                                  <label>Lab Name</label>
                                  <input
                                    type="text"
                                    name="lab_name"
                                    value={formik.values.lab_name}
                                    className="form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.lab_name && (
                                        <span className="form-error mt-1">
                                          {backendErrors.lab_name}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>
                              <div className="col-md-6">
                              <div className="form-group">
                                  <label>Date</label>
                                  <input
                                    type="date"
                                    name="date"
                                    value={formik.values.date}
                                    className="form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.date && (
                                        <span className="form-error mt-1">
                                          {backendErrors.date}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group status2">
                                  <label>Select Currency</label>
                              
                                  <Select
                             
                                        className="w-100"
                                        value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                        name="currency"
                                        onChange={(selectedOption) => {
                                          handleSelectChange("currency", selectedOption);
                                          customFuction(selectedOption);
                                          // handleGetAddressByCustomer(selectedOption);
                                        }}
                                        onBlur={formik.handleBlur}
                                        options={primaryCurrency}
                                        placeholder="Select"
                                    

                                        />
                                  <small>
                                    {backendErrors.currency && (
                                        <span className="form-error mt-1">
                                          {backendErrors.currency}
                                        </span>
                                      )}
                                  </small>
                                  </div>
                                
                                </div>
                              <div className="col-md-6">
                              <div className="form-group">
                                  <label>Price</label>
                                  <div className="input-group">
                                      <input 
                                      type="text"
                                      onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="price"
                                      value={formik.values.price}
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        customHandleInput(e);
                                      }}
                                        onBlur={formik.handleBlur}
                                      className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                      <div className="input-group-append">
                                          <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                      </div>
                                  </div>
                                  <small>
                                    {backendErrors.price && (
                                        <span className="form-error mt-1">
                                          {backendErrors.price}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>
                            
                             

                            <div className="col-md-6">
                                    <div className="form-group">
                                        <label>RM Lot or Farm</label>
                                        <input
                                          type="text"
                                          name="ram_lot_or_farm"
                                          value={formik.values.ram_lot_or_farm}
                                          className="form-input  form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.ram_lot_or_farm && (
                                              <span className="form-error mt-1">
                                                {backendErrors.ram_lot_or_farm}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                </div>
                              <div className="col-md-6">
                              <div className="form-group status">
                                  <label>Product</label>
                                  {productLists.length > 0 && (
                                    <Select
                                    className="w-100"
                                    value={productLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                    name="product"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("product", selectedOption);
                                     // handleGetAddressByCustomer(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={productLists}
                                    placeholder="Select"
   
                                  />
                                  )}
                                  
                                  <small>
                                    {backendErrors.product && (
                                        <span className="form-error mt-1">
                                          {backendErrors.product}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>
                               <div className="col-md-6">
                                  <div className="form-group status">
                                      <label>Product Type</label>
                                        {productLists.length > 0 && (
                                      <Select
                                        className="w-100"
                                        value={productType.find(option => option.value == formik.values.product_type) || null} // Ensure correct format
                                        name="product_type"
                                        onChange={(selectedOption) => {
                                          handleSelectChange("product_type", selectedOption);
                                        }}
                                        onBlur={formik.handleBlur}
                                        options={productType}
                                        placeholder="Select"
                                      />
                                        )}
                                      
                                      <small>
                                        {backendErrors.product_type && (
                                            <span className="form-error mt-1">
                                              {backendErrors.product_type}
                                            </span>
                                          )}
                                      </small>
                                    </div>
                                  </div>
                              <div className="col-md-6">
                              <div className="form-group status">
                                  <label>File</label>
                                
                                      <input
                                        className="form-control"
                                        type="file"
                                        name="file"
                                        onChange={(event) => {
                                          const file_link = event.target.files[0];
                                          //console.log("file:", file_link);
                                          //const fileName = file_link.name;
                                         // const fileName = file_link.name;
                                          const reader = new FileReader();

                                          reader.onloadend = () => {
                                            formik.setFieldValue(
                                              "file",
                                              reader.result
                                            );
                                          };
        
                                          if (file_link) {
                                            reader.readAsDataURL(file_link);
                                          }
                                        }}
                                      />
                                      {raw_data_invoice != '' && (
                                    <Link target="_blank"  to={raw_data_invoice}>Download</Link>
                                  )}
                                <small>
                                    {backendErrors.file && (
                                        <span className="form-error mt-1">
                                          {backendErrors.file}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group status">
                                    <label>Farm</label>
                                     {farmLists.length > 0 && (
                                      <Select
                                          className="w-100"
                                          value={farmLists.find(option => option.value == formik.values.farm) || null} // Ensure correct format
                                          name="farm"
                                          onChange={(selectedOption) => {
                                            handleSelectChange("farm", selectedOption);
                                            // handleGetAddressByCustomer(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={farmLists}
                                          placeholder="Select"
                                      />
                                     )}
                                      
                                    <small>
                                      {backendErrors.farm && (
                                          <span className="form-error mt-1">
                                            {backendErrors.farm}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                            </div>
                          
                               <div className="col-md-6">
                                <div className="form-group status">
                                    <label>Processing Line</label>
                                  {locationLists.length > 0 && (
                                    <Select
                                      className="w-100"
                                      value={locationLists.find(option => option.value == formik.values.processing_line) || null} // Ensure correct format
                                      name="processing_line"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("processing_line", selectedOption);
                                        // handleGetAddressByCustomer(selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={locationLists}
                                      placeholder="Select"
                                    />
                                  )}

                                    
                                    <small>
                                      {backendErrors.processing_line && (
                                          <span className="form-error mt-1">
                                            {backendErrors.processing_line}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                            </div>
                              <div className="col-md-12">
                              <div className="form-group">
                                  <label>Note</label>
                                  <textarea
                                    type="text"
                                    name="result"
                                    value={formik.values.result}
                                    className="form-input form-control"
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  ></textarea>
                                  <small>
                                    {backendErrors.result && (
                                        <span className="form-error mt-1">
                                          {backendErrors.result}
                                        </span>
                                      )}
                                  </small>
                                </div>
                              </div>

                            </div>

                        
                          
                            <div className="text-end mt-4">
                              <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                              Update Quality
                              </button>
                            </div>
                          </form>
                        </FormikProvider>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityEdit;
